import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import { SiteImagesProvider } from "@/context/SiteImagesContext";

const LegalPage = lazy(() => import("@/pages/LegalPage"));
const AdminLogin = lazy(() => import("@/admin/AdminLogin"));
const AdminLayout = lazy(() => import("@/admin/AdminLayout"));
const AdminDashboard = lazy(() => import("@/admin/AdminDashboard"));
const AdminQuotes = lazy(() => import("@/admin/AdminQuotes"));
const AdminSettings = lazy(() => import("@/admin/AdminSettings"));
const AdminPortfolio = lazy(() => import("@/admin/AdminPortfolio"));
const AdminImages = lazy(() => import("@/admin/AdminImages"));
const InvoiceList = lazy(() => import("@/admin/invoices/InvoiceList"));
const InvoiceEditor = lazy(() => import("@/admin/invoices/InvoiceEditor"));
const PayInvoicePage = lazy(() => import("@/pages/pay/PayInvoicePage"));
const PaySuccessPage = lazy(() => import("@/pages/pay/PaySuccessPage"));

const Fallback = () => <div className="min-h-screen bg-ink" aria-busy="true" />;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteImagesProvider>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/terms" element={<LegalPage type="terms" />} />
            <Route path="/pay/:token" element={<PayInvoicePage />} />
            <Route path="/pay/:token/success" element={<PaySuccessPage />} />
            <Route
              path="/admin/*"
              element={
                <AdminAuthProvider>
                  <Routes>
                    <Route index element={<AdminLogin />} />
                    <Route element={<AdminLayout />}>
                      <Route path="dashboard" element={<AdminDashboard />} />
                      <Route path="quotes" element={<AdminQuotes />} />
                      <Route path="archived" element={<AdminQuotes archived />} />
                      <Route path="settings" element={<AdminSettings />} />
                      <Route path="portfolio" element={<AdminPortfolio />} />
                      <Route path="images" element={<AdminImages />} />
                      <Route path="invoices" element={<InvoiceList />} />
                      <Route path="invoices/new" element={<InvoiceEditor />} />
                      <Route path="invoices/:id" element={<InvoiceEditor />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/admin" replace />} />
                  </Routes>
                </AdminAuthProvider>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        </SiteImagesProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ className: "!bg-surface !border-white/10 !text-white" }} />
    </div>
  );
}

export default App;
